module.exports = __webpack_public_path__ + "img/time.2627c368.svg";